const STORAGE_KEY = "areaVehicleSettings"

const safeParse = (value) => {
  try {
    return value ? JSON.parse(value) : {}
  } catch (error) {
    console.warn("vehicleStorage: failed to parse settings", error)
    return {}
  }
}

export const getVehicleSettingsMap = () => {
  if (typeof window === "undefined") return {}
  const raw = window.localStorage.getItem(STORAGE_KEY)
  return safeParse(raw)
}

export const saveVehicleSettingsMap = (map) => {
  if (typeof window === "undefined") return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
}

export const getVehicleSettingsForArea = (areaId) => {
  if (areaId === null || areaId === undefined) return undefined
  const map = getVehicleSettingsMap()
  return map[String(areaId)]
}

export const setVehicleSettingsForArea = (areaId, data) => {
  if (areaId === null || areaId === undefined) return
  const map = getVehicleSettingsMap()
  map[String(areaId)] = data
  saveVehicleSettingsMap(map)
}
